// note this input component accepts formik prop

import React from 'react';
import PropTypes from 'prop-types';

import {
  STRING_FIELD_EMAIL_ADDRESS,
} from '../labels';

import FormikLabeledField from './FormikLabeledField';

import formikPropTypes from './formikPropTypes';

export function EmailAddressField({
  disabled, name, onChange, formikProps,
}) {
  return (
    <FormikLabeledField
      disabled={disabled}
      name={name}
      onChange={onChange}
      formikProps={formikProps}
      label={STRING_FIELD_EMAIL_ADDRESS}
      placeholder={STRING_FIELD_EMAIL_ADDRESS}
      type="email"
    />
  );
}

EmailAddressField.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  formikProps: formikPropTypes.isRequired,
};

EmailAddressField.defaultProps = {
  disabled: false,
  onChange: () => {},
};

export default EmailAddressField;
